import { render, staticRenderFns } from "./OverviewComparisonInsights.vue?vue&type=template&id=2e529d6a"
import script from "./OverviewComparisonInsights.vue?vue&type=script&lang=js"
export * from "./OverviewComparisonInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports